// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    getEventsError: {
        id: 'contact-sensor.getting-events-error',
        defaultMessage: "There was an error retrieving your device's events"
    }
});



// WEBPACK FOOTER //
// ./src/core/state/products/contact-sensor/intl.js